import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 18088 18178"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#2b2a29}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528319403648">
        <path
          d="M15594 18178c-95 0-170-75-170-170V2374H2667v15634c0 95-76 170-170 170-95 0-171-75-171-170V2203c0-94 76-170 171-170h13097c94 0 170 76 170 170v15805c-2 95-78 170-170 170z"
          className="fil0"
        />
        <path
          d="M14034 14417H4056c-94 0-170-76-170-170V2203c0-94 76-170 170-170h9978c94 0 170 76 170 170v12044c0 94-76 170-170 170zm-9810-338h9638V2376H4224v11703z"
          className="fil0"
        />
        <path
          d="M16668 16762c-95 0-171-76-171-170V2376H1591v14216c0 94-76 170-171 170-94 0-170-76-170-170V2205c0-94 76-170 170-170h15246c94 0 170 76 170 170v14387c2 94-76 170-168 170z"
          className="fil0"
        />
        <path
          d="M17918 2374H170c-94 0-170-76-170-171V170C0 76 76 0 170 0h17748c94 0 170 76 170 170v2033c0 95-76 171-170 171zM340 2033h17408V340H340v1693zM14928 3378H3158c-94 0-170-76-170-170s76-170 170-170h11770c94 0 170 76 170 170s-76 170-170 170zM14928 4382H3158c-94 0-170-76-170-170s76-170 170-170h11770c94 0 170 76 170 170s-76 170-170 170zM14928 5385H3158c-94 0-170-76-170-171 0-94 76-170 170-170h11770c94 0 170 76 170 170 0 95-76 171-170 171zM14928 6389H3158c-94 0-170-76-170-170s76-170 170-170h11770c94 0 170 76 170 170s-76 170-170 170zM14928 7393H3158c-94 0-170-76-170-170s76-170 170-170h11770c94 0 170 76 170 170s-76 170-170 170zM14928 8395H3158c-94 0-170-75-170-170 0-94 76-170 170-170h11770c94 0 170 76 170 170 0 95-76 170-170 170zM14928 9400H3158c-94 0-170-76-170-170 0-95 76-170 170-170h11770c94 0 170 75 170 170 0 94-76 170-170 170zM14928 10404H3158c-94 0-170-76-170-170s76-170 170-170h11770c94 0 170 76 170 170s-76 170-170 170zM14928 11406H3158c-94 0-170-76-170-170s76-170 170-170h11770c94 0 170 76 170 170s-76 170-170 170zM14928 12411H3158c-94 0-170-76-170-171 0-94 76-170 170-170h11770c94 0 170 76 170 170 0 95-76 171-170 171zM14928 13415H3158c-94 0-170-76-170-170s76-170 170-170h11770c94 0 170 76 170 170s-76 170-170 170zM14928 14417H3158c-94 0-170-76-170-170s76-170 170-170h11770c94 0 170 76 170 170s-76 170-170 170z"
          className="fil0"
        />
        <path
          d="M12687 15784c-94 0-170-75-170-170v-1367c0-94 76-170 170-170 95 0 170 76 170 170v1367c0 95-75 170-170 170z"
          className="fil0"
        />
        <path
          d="M13052 17344h-728c-94 0-170-76-170-170v-1560c0-94 76-170 170-170h728c94 0 170 76 170 170v1560c-2 94-78 170-170 170zm-557-340h387v-1220h-387v1220z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
